// @flow
import React, { type Node } from 'react';
import { useUserInputAsSelect } from '@tectonics/prs/user-input-values';
import styled from 'styled-components';
import { Select, SelectOption } from '../../../atoms';
import { NoStyleDiv } from '../../../organisms/shared-styled-components';
import { RenderTheInstructions } from '../commons/render-the-instructions';

export function RenderEfectivoNode(): Node {
  return (
    <Container>
      <SubText>Presente este cupon en cualquier tienda afiliada de PagosNet:</SubText>
      <BankingImageContainer>
        {
          bankImagesList.map((bank, index) => {
            return (
              <SingleImageContainer key={index}>
                <BankingImage src={bank.imgSrc} alt={bank.altText} />
              </SingleImageContainer>
            );
          })
        }
      </BankingImageContainer>
    </Container>
  );
}

const renderOptions = (optionsObject) => {
  let optionValues = [];
  Object.keys(optionsObject).forEach((option, index) => {
    optionValues.push(option);
  });
  return (
    optionValues.map((option, index) => {
      return <SelectOption key={index} value={option}>{option}</SelectOption>;
    })
  );
};

export function RenderEBankingNode(): Node {
  const [eBankingValue = 'EBISA', handleChangeEBanking] = useUserInputAsSelect('ebanking-options');
  return (
    <NoStyleDiv>
      <SubText position="left">Banco</SubText>
      <div>
        <Select id="transfer" value={eBankingValue} onChange={handleChangeEBanking} readOnly={false} name="ebanking-options">
          {renderOptions(eBankingOptions)}
        </Select>
      </div>
      <RenderTheInstructions eBankingValue={eBankingValue} eBankingOptions={eBankingOptions} />
    </NoStyleDiv>
  );
}

const Container = styled.div`
  width: 100%;
`;

const SubText = styled.div`
  color: ${props => props.theme.colors.mediumGray(7, 54)};
  width: ${props => props.position === 'left' ? '100%' : '70%'};
  margin-left: auto;
  margin-right: auto;
  margin-bottom: 1em;
  text-align:left;
`;

const BankingImageContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  width: 100%;
  flex-direction: row;
`;

const SingleImageContainer = styled.div`
  flex-basis: 33%;
`;

const BankingImage = styled.img`
  border: solid 1px ${props => props.theme.colors.mediumGray(7, 54)};
  border-radius: 5px;
  width: 80px;
  @media screen and (min-width: 500px) {
    width: 110px;
  }
  src: ${props => props.src ? props.src : ''};
`;

const bankImagesList = [
  {
    imgSrc: 'https://s3-us-west-1.amazonaws.com/cdn.ebanx.com/images/small/banco-fassil-sm.png',
    altText: 'banco fassil',
  },
  {
    imgSrc: 'https://s3-us-west-1.amazonaws.com/cdn.ebanx.com/images/small/logo_prodem-sm.png',
    altText: 'prodem',
  },
  {
    imgSrc: 'https://s3-us-west-1.amazonaws.com/cdn.ebanx.com/images/small/logo_crecer-sm.png',
    altText: 'crecer',
  },
  {
    imgSrc: 'https://s3-us-west-1.amazonaws.com/cdn.ebanx.com/images/small/logo_bcp-sm.png',
    altText: 'bcp',
  },
  {
    imgSrc: 'https://s3-us-west-1.amazonaws.com/cdn.ebanx.com/images/small/logo_ecofuturo-sm.png',
    altText: 'ecofuturo',
  },
  {
    imgSrc: 'https://s3-us-west-1.amazonaws.com/cdn.ebanx.com/images/small/logo_farmacorp-sm.jpg',
    altText: 'farmacorp',
  },
  {
    imgSrc: 'https://s3-us-west-1.amazonaws.com/cdn.ebanx.com/images/small/logo_ebisa-sm.png',
    altText: 'ebisa',
  },
  {
    imgSrc: 'https://s3-us-west-1.amazonaws.com/cdn.ebanx.com/images/small/logo_laprimera-sm.png',
    altText: 'laprimera',
  },
];

const eBankingOptions = {
  EBISA: [
    'Ingresa con tu usuario y contraseña.',
    'Selecciona Operaciones de pago > Servicios Online > PagosNet.',
    'Escoge la cuenta a debitar.',
    'Introduce el criterio de la búsqueda y listo.',
  ],
  BCP: [
    'Ingresa con tu usuario y clave de internet.',
    'Verifica los datos de la cuenta y pulsa en Continuar.',
    'Selecciona Pagos > Pagos del servicio > PagosNet.',
    'En Buscar por introduce el criterio de  la búsqueda.',
    'Escoge la cuenta a debitar y listo.',
  ],
};
